export const types = {

    authChekingFinish: '[auth] Finish Cheking login state ',
    authStartLogin: '[auth] Start Login',
    authLogin: '[auth] Login',
    authStartRegister: '[auth] Start Register',
    authStartTokenRenew: '[auth] Start token renew',
    authLogOut: '[auth] LogOut',

    uiOpenModal: '[ui] Open modal',
    uiCloseModal: '[ui] Close modal',


    
    productStartAddNew:'[product] Start Add new',
    
    productAddNew: '[product] Add new',
    productUpdate: '[product] Updated',
    productDelete: '[product] Deleted',
    productLoaded: '[product] ProductsDB Loaded',

    sellAddNew: '[sell] Add new',
    sellUpdate: '[sell] Updated',
    sellDelete: '[sell] Deleted',
    sellLoaded: '[sell] Sells Loaded',


    authCartAddNew: '[auth] cartAddNew',
    authCartDeleted: '[auth] cartDeleted',
    authCartClean: '[auth] cartClean'

}